import Paragraph from 'src/design/components/bodyText/Paragraph';
import HelpDisclaimerText from 'src/design/components/helpDisclaimer/HelpDisclaimerText';

const HelpDisclaimer = ({ children, className }) =>
  <Paragraph className={className}>
    <HelpDisclaimerText>{children}</HelpDisclaimerText>
  </Paragraph>;

export default HelpDisclaimer;
